import { StoreConfig } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/store_config_pb'
import React from 'react'

import { EventDurationBadge } from '@/components/booking/shared/event-duration-badge'
import { formatPriceInCents } from '@/lib/dinero/utils'
import { BookingSelection } from '@/lib/hooks/use-booking-selection'

type Props = {
  bookingSelection: BookingSelection
  storeConfig?: StoreConfig
}

export const BookingSelectionSummary = ({
  bookingSelection,
  storeConfig,
}: Props) => {
  return (
    <div className="mt-8 flex flex-row items-center justify-between">
      <div className="flex flex-row items-center gap-4">
        <div className="text-lg font-semibold">
          {bookingSelection.bookingItemsTitle}
        </div>
        <div>
          <EventDurationBadge duration={bookingSelection.bookingItemsLength} />
        </div>
      </div>

      <div className="text-lg font-semibold">
        {bookingSelection.bookingItemsPriceInCents > 0
          ? formatPriceInCents(
              bookingSelection.bookingItemsPriceInCents,
              storeConfig?.currency || 'usd',
              true,
            )
          : ''}
      </div>
    </div>
  )
}
